module.exports = __webpack_public_path__ + "img/grid-boxer.7b46f511.webp";